export class signUpModel {
  "consumerId" : string = "";
  "consumerName" : string = "";
  "consumerMobile" : string = "";
  "consumerEmail" : string = "";
  "consumerPass" : string = "";
  "consumerOtp" : string = "";
  "consumerConfirmPass": string = "";
  "consumerPAN" : string = "";
  "consumerAADHAAR" : string = "";
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/signup/signup.model.ts